// noinspection JSUnusedGlobalSymbols

import AppConfig from '../../../config/app.configuration.json';
import ApiConfig from '../../../config/api.configuration.json';
import Policies from '../../../config/policies.configuration.json';
import Pages from '../../../config/page.content.json';

export const config = AppConfig.config;

export const api = ApiConfig.iSudio;
export const ipLookup = ApiConfig.ipLookup;

type RouteKeys = keyof typeof api.routes;
const _routes: Record<RouteKeys, RouteKeys> = Object.keys(
  api.routes
).reduce((acc, key) => {
  const routeKey = key as RouteKeys;
  acc[routeKey] = routeKey;
  return acc;
}, {} as Record<RouteKeys, RouteKeys>);

export const routes = JSON.parse(JSON.stringify(_routes));

export const db = {
  ...config.db.remote.names,
  ...config.db.local.indexeddb.names,
  ...config.db.local.memory.names
}

const _policies = Object.fromEntries(
  Policies.policies.map((policy) => [policy.type, policy])
) as {
  userPolicy: typeof Policies.policies[number] & { type: "userPolicy" };
  privacyPolicy: typeof Policies.policies[number] & { type: "privacyPolicy" };
  termsOfUse: typeof Policies.policies[number] & { type: "termsOfUse" };
};

export const policies = JSON.parse(JSON.stringify(_policies));

export const pages = Pages.content;

export const styles = Pages.styles;
